"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercialLineItemUpdate = exports.CommercialLineItemNestedCreate = exports.CommercialLineItemCreate = exports.CommercialLineItemQuery = exports.SubscriptionCommercialLineItemTransport = exports.CommercialLineItemTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const CommercialLineItemType_1 = require("./CommercialLineItemType");
const commercial_line_item_shared_1 = require("./commercial-line-item-shared");
exports.CommercialLineItemTransport = commercial_line_item_shared_1.CommercialLineItemSharedFields;
exports.SubscriptionCommercialLineItemTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(commercial_line_item_shared_1.CommercialLineItemSharedFields, ['billingDetailsID', 'onBillID', 'sku', 'name']),
    typebox_1.Type.Object({
        name: typebox_1.Type.Optional(typebox_1.Type.String()),
        sku: CommercialLineItemType_1.SubscriptionEventCommercialLineItemTypeTransport,
        onBill: typebox_1.Type.Optional(typebox_1.Type.Object({
            id: typebox_1.Type.String({ format: 'uuid' }),
            haulerID: typebox_1.Type.String({ format: 'uuid' }),
            customerID: typebox_1.Type.String({ format: 'uuid' }),
            estimatedTax: typebox_1.Type.Optional(typebox_1.Type.Integer()),
            subTotal: typebox_1.Type.Integer(),
            total: typebox_1.Type.Optional(typebox_1.Type.Integer()),
            date: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date', description: 'deprecated' })),
            issueDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
            dueDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
            autopayDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
            billingPeriodStart: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
            billingPeriodEnd: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
            receivableID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
            amountPaid: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
            billNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
        })),
    }),
]);
exports.CommercialLineItemQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([common_1.BaseQuery, commercial_line_item_shared_1.CommercialLineItemSharedQuery]));
exports.CommercialLineItemCreate = commercial_line_item_shared_1.CommercialLineItemSharedCreateFields;
exports.CommercialLineItemNestedCreate = commercial_line_item_shared_1.CommercialLineItemSharedNestedCreateFields;
exports.CommercialLineItemUpdate = commercial_line_item_shared_1.CommercialLineItemSharedUpdateFields;
//# sourceMappingURL=CommercialLineItem.js.map